function updateCartCount() {
  fetch("/cart.js")
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      // Update the cart item count on the page
      document.querySelector(".cart-count").innerHTML = cart.item_count;
    });
}

setInterval(updateCartCount, 1000);

$(document).ready(function () {
  $(document).on("click", ".accordion-list .accordion__content input", function () {
    setTimeout(function () {
      var dataCount = parseInt(
        $(".collection-toolbar__products-count").attr("data-count")
      );
      $(".facets-drawer .count-filter-own").text("(" + dataCount + ")");
    }, 2000);
  });
});

$(document).ready(function() {
  var inventoryDiv = $('[data-block-type="inventory"]');
  var appDiv = $('[data-block-type="@app"]');
  
  if (inventoryDiv.length && appDiv.length) {
    appDiv.insertAfter(inventoryDiv);
  }
});


$(document).ready(function(){
  $('.nls-custom-slider').slick({
    infinite: true,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    speed: 300,
    autoplay: false,
    arrows: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4.2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.2
      }
    }
  ]      
  });
});

// product card js element display block and none start
document.addEventListener("DOMContentLoaded", function () {
  function toggleAnchors() {
    if (window.innerWidth <= 767) {
      document.querySelectorAll('.custom-product-desktop').forEach(el => el.remove());
    } else {
      document.querySelectorAll('.custom-product-mobile').forEach(el => el.remove());
    }
  }

  function initSwiper() {
    if (window.innerWidth <= 767) {
      document.querySelectorAll('.custom-swiper-container').forEach(function (swiperContainer) {
        if (!swiperContainer.classList.contains('swiper-initialized')) {
          new Swiper(swiperContainer, {
            loop: true,
            scrollbar: {
              el: ".swiper-scrollbar",
              hide: false,
            },
          });

          swiperContainer.classList.add('swiper-initialized'); 
        }
      });
    }
  }

  function handleUpdates() {
    toggleAnchors(); 
    initSwiper();
  }

  //  Run functions on page load
  handleUpdates();

  //  Run functions on window resize
  window.addEventListener("resize", handleUpdates);

  //  Run functions when AJAX content loads (jQuery)
  $(document).on("ajaxComplete", function () {
    setTimeout(handleUpdates, 500);
  });

  // Run functions when Fetch API completes
  function observeFetch() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch(...args).then((response) => {
        if (response.ok) {
          response.clone().json().then(() => {
            setTimeout(handleUpdates, 500);
          });
        }
        return response;
      });
    };
  }
  observeFetch();

  //  Observe new elements in DOM (MutationObserver)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(handleUpdates, 500);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
// product card js element display block and none end

